import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

// modules
import auth from './modules/ssoLogin'
import vendor from './modules/vendor'
import brokerImg from '../assets/download.png'
import httpService from './httpService'

const aliceblueLogo = `https://aliceblueonline.com/assets/favicon.png`
Vue.use(Vuex)
export default new Vuex.Store({

  state: {
    build_time: '08_08_2023_17_30',
    brokerName: 'Aliceblue',
    brokerLogo: brokerImg,
    userId: '',
    sessionId: '',
    apiKeyDetails: '',
    apiKeyConfirmDialog: false,
    apiKeyLoader: false
  },
  mutations: {
    setUserId (state, payload) {
      state.userId = payload
    },
    setSessionId (state, payload) {
      state.sessionId = payload
    },
    setApiKeyDetails(state,payload){
      state.apiKeyDetails = payload
    },
    setApiKeyConfirmationDialog(state,payload) {
      state.apiKeyConfirmDialog = payload
      
    },
    setApiKeyLoader(state,payload){
      state.apiKeyLoader = payload
    }
  },
  actions: {
    unAuthorized({commit}, payload){
      commit('setUserId', '')
      commit('setSessionId', '')
      if (payload.response.status == 401) {
        localStorage.clear();
        router.push({path: "/", query: {logout: "true"}}).catch(() => {});
    }
    },
    getApiKey({commit}){
      commit('setApiKeyLoader', true)
      httpService.getApiKey().then((res)=> {
        if(res.status==200 && res.data.status == 'Not ok' && res.data.message == 'API key not available. Please generate API key' ) {
commit('setApiKeyDetails', '')
        }  else if (res.status == 200 && res.data.message == 'Success' && res.data.status == 'Ok' && res.data.result && res.data.result.length > 0) {
          commit('setApiKeyDetails', res.data.result[0])
        }
      }).finally(()=> {
        commit('setApiKeyLoader', false)

      })
    },
    generateApiKey({commit, dispatch}){
      let json = {
        source: 'WEB'
      }
      httpService.generateApiKey(json).then((res)=> {
if(res.status == 200 && res.data.message == 'Success' && res.data.status == 'Ok') {
  dispatch('getApiKey')
}
      })
    },
    reGenerateApiKey({commit, dispatch}) {
      let json = {
        source: 'WEB'
      }
      httpService.reGenerateApiKey(json).then((res)=> {
        if(res.status == 200 && res.data.message == 'Success' && res.data.status == 'Ok') {
          dispatch('getApiKey')
        }
      })
    }
  },
  getters: {
    getBrokerName: state => state.brokerName,
    getBrokerLogo: state => state.brokerLogo,
    getUserId: state => state.userId,
    getSessionId: state => state.sessionId,
  },
  modules: { auth, vendor }
})
